export default {"src":"/_next/static/media/full_logo.233f3201.svg","height":100,"width":554,"blurWidth":0,"blurHeight":0};